import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import PageShell from './PageShell';
import { marketApi, watchlistApi } from './api';

export default function WatchlistsPage() {
  const [symbols, setSymbols] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [newTicker, setNewTicker] = useState('');
  const [error, setError] = useState(null);

  const load = async () => {
    try {
      const data = await watchlistApi.list();
      setSymbols(data || []);
      if (data?.length) {
        const quotesData = await marketApi.quotes(data);
        setQuotes(quotesData || []);
      } else {
        setQuotes([]);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    load();
    const interval = setInterval(load, 20000);
    return () => clearInterval(interval);
  }, []);

  const handleAdd = async (event) => {
    event.preventDefault();
    if (!newTicker.trim()) return;
    try {
      const updated = await watchlistApi.add(newTicker.trim().toUpperCase());
      setSymbols(updated || []);
      setNewTicker('');
      await load();
    } catch (err) {
      setError(err.message);
    }
  };

  const quoteMap = useMemo(() => Object.fromEntries(quotes.map((quote) => [quote.symbol, quote])), [quotes]);

  return (
    <PageShell title="Watchlists" subtitle="Organize your market watch and jump into any symbol instantly." breadcrumbs={[{ label: 'Home' }, { label: 'Watchlists' }]} activeTab="watchlists">
      <section className="dashboard-section">
        <form className="watchlist-add" onSubmit={handleAdd}>
          <input value={newTicker} onChange={(event) => setNewTicker(event.target.value.toUpperCase())} placeholder="Add symbol" />
          <button type="submit" className="secondary-button">
            Add to watchlist
          </button>
        </form>
        {error && <div className="error-box">{error}</div>}
        <div className="watchlist-card-list">
          {symbols.length === 0 ? (
            <div className="empty-state">
              <p>None saved yet</p>
              <small>Add a ticker to start building a focused watchlist.</small>
            </div>
          ) : (
            symbols.map((symbol) => {
              const quote = quoteMap[symbol];
              return (
                <div key={symbol} className="watchlist-card-item">
                  <div>
                    <Link to={`/stocks/${symbol}`} className="stock-link strong">
                      {symbol}
                    </Link>
                    <p className="muted">Quick access to quote, chart, and trade actions.</p>
                  </div>
                  {quote ? (
                    <div className="watchlist-metric">
                      <strong>${Number(quote.price || 0).toFixed(2)}</strong>
                      <span className={Number(quote.change || 0) >= 0 ? 'up' : 'down'}>
                        {Number(quote.change || 0) >= 0 ? '▲' : '▼'} {Math.abs(Number(quote.changePercent || 0)).toFixed(2)}%
                      </span>
                    </div>
                  ) : (
                    <span className="muted">Loading…</span>
                  )}
                </div>
              );
            })
          )}
        </div>
      </section>
    </PageShell>
  );
}
